import {RecaptchaWindow} from "../types/Types";

const loadRecaptcha = () => {
  if (typeof (<RecaptchaWindow>window).grecaptcha !== "undefined") {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.defer = true;
  script.src = "https://www.google.com/recaptcha/api.js";
  document.body.appendChild(script);
}

export default loadRecaptcha;
